import CheckPermissions from 'components/CheckPermissions';
import getMeetingStatusContext from 'contexts/MeetingStatusContext';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as classroomActions from 'store/classroom/classroomActions';
import PropTypes from 'prop-types';

MeetingStatusProvider.propTypes = {
  children: PropTypes.node,
};
export default function MeetingStatusProvider({ children }) {
  const MeetingStatusContext = getMeetingStatusContext();
  const { userId, meetingStatus } = useSelector(({ user, chime }) => ({
    userId: user.userId,
    meetingStatus: chime.meetingStatus,
  }));

  const queryRef = new URLSearchParams(useLocation().search);
  const query = useRef(queryRef);
  query.current = queryRef;
  const audioElement = useRef(null);
  const [hasCheckedPermissions, setHasCheckedPermissions] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (hasCheckedPermissions) {
      dispatch(
        classroomActions.joinMeetingAction({
          audioRef: audioElement.current,
          externalMeetingId: query.current.get('title'),
          externalUserId: userId,
          region: query.current.get('region'),
        })
      );
    }
  }, [hasCheckedPermissions, dispatch, userId]);

  return (
    <MeetingStatusContext.Provider value={meetingStatus}>
      <CheckPermissions
        hasCheckedPermissions={hasCheckedPermissions}
        setHasCheckedPermissions={setHasCheckedPermissions}
      />
      <audio ref={audioElement} style={{ display: 'none' }} />
      {children}
    </MeetingStatusContext.Provider>
  );
}
